import react from "react";
import classNames from "classnames";

const classNamePaginationActive = "border-blue-300 bg-blue-500 text-white ";
const classNamePaginationNotActive =
  "border-gray-300 bg-white  text-gray-700 duration-300";

const NumberPage = ({ number, pageIndex, gotoPage, ...rest }) => {
  return (
    <button
      {...rest}
      disabled={pageIndex === number}
      // onClick={() => gotoPage(number)}
      className={classNames(
        " relative inline-flex items-center px-4 py-2 border text-sm font-medium cursor-default",
        {
          [classNamePaginationNotActive]: pageIndex !== number,
          [classNamePaginationActive]: pageIndex === number,
        }
      )}
    >
      {number + 1}
    </button>
  );
};

export default NumberPage;
